export const ACQUIRED_ASSETS = 'acquired-assets';
export const ACQUIRED_ASSETS_FILTER = 'acquired-assets-filter';
export const ACQUIRE_ASSET = 'acquire-asset';
export const ACTIVE_ALARMS = 'active-alarms';
export const ACTIVE_ALARMS_FLEXIDAS = 'active-alarms-flexidas';
export const ACTIVE_ALARMS_ORAN = 'active-alarms-oran';
export const ACTIVE_ALARMS_ORAN_ACKNOWLEDGE = 'active-alarms-oran-acknowledge';
export const ACTIVE_ALARMS_ORAN_CLEAR = 'active-alarms-oran-clear';
export const ACTIVE_ALARM_ORAN = 'active-oran-alarm';
export const ADD_SECTORS_SETTINGS = 'add-sectors-settings';
export const ADD_SITE_AND_LINK = 'add-site-and-link';
export const ALARMS_FLEXIDAS = 'alarms-flexidas';
export const ALARM_APPLICABILITIES_ORAN = 'alarm-applicabilities-oran';
export const ALARM_CREATE_NO_VES_RULE_ORAN = 'create-no-ves-rule-oran';
export const ALARM_CREATE_NO_FILE_RULE_ORAN = 'create-no-file-rule-oran';
export const ALARM_CUSTOM_ALARMS_NETWORK_ELEMENTS = 'custom-alarm-network-elements';
export const ALARM_CUSTOM_ALARMS_NO_FILE_NETWORK_ELEMENTS = 'custom-alarm-no-file-network-elements';
export const ALARM_DAS_NAMES = 'alarm-das-names';
export const ALARM_DELETE_NO_VES_RULE_ORAN = 'delete-no-ves-rule-oran';
export const ALARM_DELETE_NO_FILE_RULE_ORAN = 'delete-no-file-rule-oran';
export const ALARM_ENABLE_STATUSES_ORAN = 'alarm-enable-statuses-oran';
export const ALARM_GROUPS = 'alarm-groups';
export const ALARM_GROUPS_ORAN = 'alarm-groups-oran';
export const ALARM_GROUPS_ORAN_MANAGEMENT = 'alarm-groups-oran-management';
export const ALARM_HISTORY = 'alarm-history';
export const ALARM_HISTORY_FLEXIDAS = 'alarm-history-flexidas';
export const ALARM_IDS_ORAN = 'alarm-ids-oran';
export const ALARM_IDS_BENETEL = 'alarm-ids-benetel';
export const ALARM_LIST = 'alarm-list';
export const ALARM_LIST_ORAN = 'alarm-list-oran';
export const ALARM_LIST_RAN_COMPLAINT = 'alarm-list-ran-complaint';
export const ALARM_LIST_BENETEL = 'alarm-list-benetel';
export const ALARM_BENETEL = 'alarm-benetel';
export const ACTIVE_ALARMS_BENETEL = 'active-alarms-benetel';
export const ACTIVE_ALARM_BENETEL = 'active-alarm-benetel';
export const HISTORY_ALARMS_BENETEL = 'history-alarms-benetel';
export const HISTORY_ALARM_BENETEL = 'history-alarm-benetel';
export const ALARM_MODULE_NAMES_ORAN = 'alarm-module-names-oran';
export const ALARM_MODULE_NAMES_ORAN_MANAGEMENT = 'alarm-module-names-oran-management';
export const ALARM_NODE_TYPES = 'alarm-node-types';
export const ALARM_SEVERITIES = 'alarm-severities';
export const ALARM_SEVERITIES_FLEXIDAS = 'alarm-severities-flexidas';
export const ALARM_SEVERITIES_ORAN = 'alarm-severities-oran';
export const ALARM_SEVERITIES_ORAN_MANAGEMENT = 'alarm-severities-oran-management';
export const ALARM_STATUSES_ORAN = 'alarm-statuses-oran';
export const ALARM_STATUSES_ORAN_MANAGEMENT = 'alarm-statuses-oran-management';
export const ALARM_UPDATE_NO_VES_RULE_ORAN = 'update-no-ves-rules-oran';
export const ALARM_UPDATE_NO_FILE_RULE_ORAN = 'update-no-file-rules-oran';
export const ALARM_USERS = 'alarm-users';
export const ALL_CELLS = 'all-cells';
export const ALL_CELLS_FOR_SECTORS = 'all-cells-for-sectors';
export const ALL_FIELDS = 'asset-all-fields';
export const ALL_FIELDS_SITES = 'sites-all-fields';
export const ALL_OPERATORS_OOKLA = 'all-operators-ookla';
export const ALL_SECTORS = 'all-sectors';
export const ALREADY_RENTED_OUT_DATES = 'already-rented-out-dates';
export const ANALYSIS_SCHEMA = 'analysis-schema';
export const ANTENNA_MODELS = 'antenna-models';
export const API_DOCUMENTATION = 'api-documentation';
export const APPLY_CONFIGS_SCHEMA = 'apply-configs-schema';
export const APPROVAL_UNITS = 'approval-units';
export const APPROVAL_UNITS_LIST = 'approval-units-list';
export const APPROVAL_UNIT_INFO = 'approval-units-info';
export const ASSET = 'asset';
export const ASSETS = 'assets';
export const ASSET_ACCESS = 'asset-access';
export const ASSET_ACCESS_TYPES = 'asset-access-types';
export const ASSET_ACCESS_VISIBILITY_MODES = 'asset-access-visibility-modes';
export const ASSET_ACCESS_RESULTING_TYPES = 'asset-access-resulting-types';
export const ASSET_ACCESS_RESTRICTED = 'asset-access-restricted';
export const ASSET_ACCESS_RESTRICTED_ENABLE = 'asset-access-restricted-enable';
export const ASSET_ACCESS_RESTRICTED_DISABLE = 'asset-access-restricted-disable';
export const ASSET_ACCESS_UPDATE = 'asset-access-update';
export const ASSETS_CACHE = 'assets-cache';
export const ASSETS_CHANGE_COMMON_VALUES = 'assets-change-system-fields';
export const ASSETS_FIND = 'assets-find';
export const ASSETS_GROUP_SYSTEM_FIELDS = 'assets-group-system-fields';
export const ASSETS_LIST = 'assets-list';
export const ASSETS_LIST_DROPDOWN = 'ASSETS_LIST_DROPDOWN';
export const ASSETS_LIST_SHOW_HIDE_ALL = 'assets-list-show-hide-all';
export const ASSETS_LIST_SHOW_HIDE_FILTER = 'assets-list-show-hide-filter';
export const ASSETS_RENTED = 'assets-rented';
export const ASSETS_RENT_INCOMING_REQUESTS = 'assets-rent-incoming-requests';
export const ASSETS_RENT_OUTGOING_REQUESTS = 'assets-rent-outgoing-requests';
export const ASSETS_SUB_TYPES = 'assets-sub-types';
export const ASSETS_TYPES = 'assets-types';
export const ASSET_CART_REQUEST = 'request-list';
export const ASSET_CART_REQUEST_AVAILABLE = 'request-list-available';
export const ASSET_CART_REQUEST_COUNT = 'request-list-count';
export const ASSET_CART_REQUEST_DELETE = 'request-list-delete';
export const ASSET_CART_REQUEST_DROPDOWN = 'request-list-dropdowns-owners';
export const ASSET_CART_REQUEST_UNAVAILABLE = 'request-list-unavailable';
export const ASSET_HISTORY_PROFILE = 'asset-history-profile';
export const ASSET_HISTORY_USERS = 'asset-history-users';
export const ASSET_LOGS_FILTER = 'asset-logs-filter';
export const ASSET_PROFILE_INCOMING_REQUESTS = 'asset-profile-incoming-requests';
export const ASSET_PROFILE_OUTGOING_REQUESTS = 'asset-profile-outgoing-requests';
export const ASSET_RENT_REQUESTS_TYPES = 'asset-rent-request-types';
export const ASSET_RENT_REQUEST_CARD = 'asset-rent-request-card';
export const ASSET_RENT_REQUEST_CARD_ACCEPT_PROPOSED = 'asset-rent-request-card-accept-proposed';
export const ASSET_RENT_REQUEST_CARD_ITEMS = 'asset-rent-request-card-items';
export const ASSET_REQUEST_CREATE_DOCUMENT = 'asset-request-create-document';
export const ASSET_REQUEST_DELETE_DOCUMENT = 'asset-request-delete-document';
export const ASSET_REQUEST_DOCUMENTS = 'asset-request-documents';
export const ASSET_REQUEST_UPDATE_DOCUMENT = 'asset-request-update-document';
export const ASSET_SUBTYPE = 'asset-subtype';
export const ASSET_SYSTEM_FIELDS = 'asset-system-fields';
export const ASSET_TYPE = 'asset-type';
export const ASSET_TYPE_ICON_URL = 'asset-type-icon-url';
export const ASSET_VISIBILITY_HIDE = 'asset-visibility-hide';
export const ASSET_VISIBILITY_SHOW = 'asset-visibility-show';
export const ASSET_VISIBILITY = 'asset-visibility';
export const ASSET_VISIBILITY_TYPES = 'asset-visibility-types';
export const ASSET_VISIBILITY_UPDATE = 'asset-visibility-update';
export const ASSET_VISIBILITY_RESTRICTED = 'asset-visibility-restricted';
export const ASSET_VISIBILITY_RESTRICTED_ENABLE = 'asset-visibility-restricted-enable';
export const ASSET_VISIBILITY_RESTRICTED_DISABLE = 'asset-visibility-restricted-disable';
export const ASSIGN_APPROVAL_UNITS = 'assign-approval-units';
export const ATTACHED_TYPES_SUBTYPES = 'attached-types-subtypes';
export const AVAILABLE_APPROVAL_UNITS = 'available-approval-units';
export const AVAILABLE_GRANULARITY_DRILL_UP = 'available-granularity-drill-up';
export const ATTACH_PORTAL_FILES = 'attach-portal-files';
export const BANDS_4G_FDD = 'bands4GFdd';
export const BANDS_4G_TDD = 'bands4GTdd';
export const BANDS_5G = 'bands5G';
export const BOROUGHS = 'BOROUGHS';
export const BRANDING_SETUPS = 'branding-setups';
export const CATEGORIES = 'categories';
export const CC_CONFIG_TYPES = 'cc_config-types';
export const CC_DATES = 'cc_dates';
export const CC_MAVENIR_DATES = 'cc_mavenir-dates';
export const CC_NODES = 'cc_nodes';
export const CC_NODE_TYPES = 'cc_node-types';
export const CC_RELEASE_VERSIONS = 'cc_release-version';
export const CC_SITE_IDS = 'cc_site-ids';
export const CC_TECHNOLOGIES = 'cc_technologies';
export const CC_TREE = 'cc_tree';
export const CC_VENDORS = 'cc_vendors';
export const CELLS_BY_SITE = 'cells-by-site';
export const CELLS_FOR_SITE_SECTORS = 'cells-for-site-sectors';
export const CELLS_USED_BANDS = 'cells-used-bands';
export const CHANGE_PASSWORD = 'change-password';
export const CHANGE_SITE_LINK = 'change-site-link';
export const CHANGE_STATUS_ASSET = 'change-staus-asset';
export const CHECK_ASSET_SUBTYPE_NAME = 'check-asset-sub-type-name';
export const CHECK_ASSET_TYPE_NAME = 'check-asset-type-name';
export const CHECK_CREATE_PRESET = 'check-create-preset';
export const CHECK_UPDATE_PRESET_IS_SHARED = 'check-update-preset-is-shared';
export const CHECK_IS_SITE_IN_RADIUS = 'check-is-site-in-radius';
export const CHECK_KAI_ASSISTANT_NAME = 'check-kai-assistant-name';
export const CHECK_LINKED_SITES_COORD = 'check-linked-sites-coordinates';
export const CHECK_MILESTONE_EXISTS = 'check-milestone-exists';
export const CHECK_PASSWORD = 'check-password';
export const CHECK_PHONE_NUMBER = 'check-phone-number';
export const CHECK_POLYGON_NAME = 'check-polygon-name';
export const CHECK_PROJECT_CODE = 'check-project-code';
export const CHECK_TASK_EXISTS = 'check-task-exists';
export const CHECK_UPDATE_PRESET = 'check-update-preset';
export const CHECK_VALID_PASSWORD = 'check-valid-password';
export const CHECK_EMAIL = 'check-email-as-po';
export const CHECK_EMAIL_AS_PO = 'check-email-as-po';
export const CLEAR_CONFIGS_SCHEMA = 'clear-configs-schema';
export const CLUSTER_ZOOM_LEVEL = 'clusterZoomLevel';
export const CM_MODULE_VENDORS = 'cm-module-vendors';
export const COMMISSION = 'commission';
export const COMMISSION_HISTORY = 'commission-history';
export const COMMISSION_HISTORY_RECOUNT = 'commission-history-recount';
export const CONFIGURATION_TEMPLATE = 'configuration-template';
export const CONFIGURATION_TEMPLATES = 'configuration-templates';
export const CONFIGURATION_TEMPLATES_CHECK_CONFIG_TREE = 'configuration-templates-check-config-tree';
export const CONFIGURATION_TEMPLATES_CHECK_NAME = 'configuration-templates-check-config-tree';
export const CONFIGURATION_TEMPLATES_CONFIG_DATES = 'configuration-templates-config-dates';
export const CONFIGURATION_TEMPLATES_CONFIG_TIMESTAMPS = 'configuration-templates-config-timestamps';
export const CONFIGURATION_TEMPLATES_CONFIG_TREE = 'configuration-templates-config-tree';
export const CONFIGURATION_TEMPLATES_CONFIG_TYPES = 'configuration-templates-config-types';
export const CONFIGURATION_TEMPLATES_CONFIG_TYPES_OPTIONS = 'configuration-templates-config-types-options';
export const CONFIGURATION_TEMPLATES_USERS = 'configuration-templates-users';
export const CONFIGURATION_TEMPLATES_ASSIGNED_STATUSES = 'configuration-templates-assigned-statuses';
export const CONFIGURATION_TEMPLATES_MODEL_COLLECTIONS = 'configuration-templates-model-collections';
export const CONFIGURATION_TEMPLATES_NETWORK_ELEMENTS = 'configuration-templates-network-elements';
export const CONFIGURATION_TEMPLATES_RUN_CONFIG_TREE = 'configuration-templates-run-config-tree';
export const CONFIGURATION_TEMPLATES_SET = 'configuration-templates-set';
export const CONFIGURATION_TEMPLATES_UPDATE_CONFIG_TREE = 'configuration-templates-update-config-tree';
export const CONFIGURATION_TEMPLATES_UPDATE_NAME = 'configuration-templates-update-name';
export const CONFIGURATION_TEMPLATES_UPDATE_NOTES = 'configuration-templates-update-notes';
export const CONFIGURATION_TEMPLATES_VALIDATION_RULES = 'configuration-templates-validation-rules';
export const CONFIGURATION_TEMPLATES_VALIDATION_RULES_FOLDERS = 'configuration-templates-validation-rules-folders';
export const CONFIG_FILE_VIEW = 'config-file-view';
export const CONSISTENCY_BRANCHES_EXPORT = 'configuration-consistency-branches-export';
export const CONSISTENCY_BRANCH_EXPORT = 'configuration-consistency-branch-export';
export const CONSISTENCY_CONFIG_IDS = 'configuration-consistency-config-ids';
export const CONSISTENCY_CONFIG_TYPES = 'configuration-consistency-config-types';
export const CONSISTENCY_DATES = 'configuration-consistency-dates';
export const CONSISTENCY_DELETE_PROGRESSES = 'configuration-consistency-delete-progresses';
export const CONSISTENCY_DELTAS = 'configuration-consistency-deltas';
export const CONSISTENCY_DETAILS = 'configuration-consistency-details';
export const CONSISTENCY_DETAILS_MO_FILTERS = 'configuration-consistency-details-mo-filters';
export const CONSISTENCY_FETCH = 'configuration-consistency-fetch';
export const CONSISTENCY_GENERATE = 'configuration-consistency-generate';
export const CONSISTENCY_GET_PROGRESSES = 'configuration-consistency-get-progresses';
export const CONSISTENCY_GNB_IDS = 'configuration-consistency-gnb-ids';
export const CONSISTENCY_NODES = 'configuration-consistency-nodes';
export const CONSISTENCY_NODE_TYPES = 'configuration-consistency-node-types';
export const CONSISTENCY_PARAMETERS = 'configuration-consistency-parameters';
export const CONSISTENCY_RUN_PROGRESSES = 'configuration-consistency-run-progresses';
export const CONSISTENCY_SITE_IDS = 'configuration-consistency-site-ids';
export const CONSISTENCY_SITE_MO_NAMES = 'configuration-consistency-mo-names';
export const CONSISTENCY_TECHNOLOGIES = 'configuration-consistency-technologies';
export const CONSISTENCY_VENDORS = 'configuration-consistency-vendors';
export const CONSISTENCY_VERSIONS = 'configuration-consistency-versions';
export const CONSISTENCY_RAN_TABLE = 'configuration-consistency-ran-table';
export const CONSISTENCY_RAN_CONSISTENCY_STATUSES = 'configuration-consistency-ran-consistency-statuses';
export const CONSISTENCY_RAN_ASSIGNED_TEMPLATE = 'configuration-consistency-ran-assigned-template';
export const CONSISTENCY_RAN_MONITORING_STATUSES = 'configuration-consistency-ran-monitoring-statuses';
export const CONSISTENCY_RAN_TEMPLATES = 'configuration-consistency-ran-templates';
export const CONSISTENCY_RAN_ASSIGN_TEMPLATE = 'configuration-consistency-ran-assign-template';
export const CONSISTENCY_RAN_ENABLE_MONITORING = 'configuration-consistency-ran-enable-monitoring';
export const CONSISTENCY_RAN_ENABLE_MANY_MONITORING = 'configuration-consistency-ran-enable-many-monitoring';
export const CONSISTENCY_RAN_DISABLE_MONITORING = 'configuration-consistency-ran-disable-monitoring';
export const CONSISTENCY_RAN_DISABLE_MANY_MONITORING = 'configuration-consistency-ran-disable-many-monitoring';
export const CONSISTENCY_RAN_ASSIGN_MANY_TEMPLATE = 'configuration-consistency-ran-assign-many-template';
export const CONSISTENCY_RAN_UNASSIGN_TEMPLATE = 'configuration-consistency-ran-unassign-template';
export const CONSISTENCY_RAN_UNASSIGN_MANY_TEMPLATE = 'configuration-consistency-ran-unassign-many-template';
export const CONSISTENCY_RAN_CHECK_AVAILABLE_TEMPLATES = 'configuration-consistency-ran-check-available';
export const CONSISTENCY_RAN_GET_AVAILABLE_TEMPLATES = 'configuration-consistency-ran-get-available';
export const CONSISTENCY_CHECK_HISTORY = 'configuration-consistency-check-history';
export const CONSISTENCY_CHECK_HISTORY_SUMMARY = 'configuration-consistency-check-history-summary';
export const CONSISTENCY_CHECK_HISTORY_SUMMARY_PATH_STATUSES = 'configuration-consistency-check-history-summary-path-statuses';
export const CONSISTENCY_CHECK_HISTORY_INFO = 'configuration-consistency-check-history-info';
export const CONSISTENCY_CHECK_HISTORY_INFO_SUMMARY = 'configuration-consistency-check-history-info-summary';
export const CONSISTENCY_CHECK_HISTORY_TEMPLATES = 'configuration-consistency-check-history-templates';
export const CONSISTENCY_CHECK_HISTORY_DETAILS = 'configuration-consistency-check-history-details';
export const CONSISTENCY_CHECK_HISTORY_MANAGED_IDS = 'configuration-consistency-check-history-managed-ids';
export const CONSISTENCY_CHECK_HISTORY_MANAGED_NAMES = 'configuration-consistency-check-history-managed-names';
export const CONSISTENCY_CHECK_HISTORY_CHANGED_TYPES = 'configuration-consistency-check-history-changed-types';
export const CONSISTENCY_CHECK_HISTORY_USERS = 'configuration-consistency-check-history-users';
export const CONSISTENCY_CHECK_HISTORY_EXPORT = 'configuration-consistency-check-history-export';
export const CONSISTENCY_CHECK_HISTORY_STATISTICS = 'configuration-consistency-check-history-statistics';
export const CONSISTENCY_CHECK_HISTORY_CONSISTENCY_STATUSES = 'configuration-consistency-check-history-consistency-statuses';
export const CONSISTENCY_CHECK_HISTORY_MONITORING_STATUSES = 'configuration-consistency-check-history-monitoring-statuses';
export const CONSISTENCY_CHECK_HISTORY_TRIGGER_SOURCES = 'configuration-consistency-check-history-trigger-sources';
export const CONSISTENCY_CHECK_EXTRA_PATH_MO_NAMES = 'configuration-consistency-check-extra-path-mo-names';
export const CONSISTENCY_CHECK_EXTRA_PATH_MO_IDS = 'configuration-consistency-check-extra-path-mo-ids';
export const CONSISTENCY_CHECK_EXTRA_PATH_DETAILS = 'configuration-consistency-check-extra-path-mo-details';
export const CONTACT_PERSONS = 'contact-persons';
export const CORRELATION = 'correlation';
export const COUNTERS_GROUP = 'counters-group';
export const COUNTRIES = 'countries';
export const CREATE_APPROVAL_UNIT = 'create-approval-unit';
export const CREATE_ASSET = 'create-asset';
export const CREATE_ASSET_SUB_TYPE = 'create-asset-sub-type';
export const CREATE_ASSET_TYPE = 'create-asset-type';
export const CREATE_ASSIGNMENT_APPROVAL_UNIT = 'create-assignment-approval-unit';
export const CREATE_BRANDING_SETUP = 'create-branding-setup';
export const CREATE_CELL_4G_FDD = 'create-cell-4G-fdd';
export const CREATE_CELL_4G_TDD = 'create-cell-4G-tdd';
export const CREATE_CELL_5G = 'create-cell-5G';
export const CREATE_KAI_ASSISTANT = 'create-kai-assistant';
export const CREATE_KPI_ALERT = 'CREATE_KPI_ALERT';
export const CREATE_PRESET = 'create-preset';
export const CREATE_PRESET_THRESHOLDS = 'create-preset-thresholds';
export const CREATE_PRESET_TREE = 'create-preset-tree';
export const CREATE_PROJECT = 'create-project';
export const CREATE_SCHEMA = 'create-schema';
export const CREATE_SITE = 'create-site';
export const CREATE_TECHNOLOGY = 'create-technology';
export const CREATE_YANG_FILES = 'create-yang-fils';
export const CROWDCELLS = 'crowdcells';
export const CROWDCELLS_CONFIG_DATA = 'crowdCellConfigData';
export const CROWDCELLS_DATE_EXISTS = 'crowdCellDateExists';
export const CROWDCELL_CARD = 'crowdcell-card';
export const CROWD_CELL_CREATE_PRESETS = 'crowd-cell-create-preset';
export const CROWD_CELL_DELETE_PRESETS = 'crowd-cell-delete-preset';
export const CROWD_CELL_EDIT_PRESETS = 'crowd-cell-edit-preset';
export const CROWD_CELL_PRESETS = 'crowd-cell-presets';
export const CUSTOM_POLYGON = 'custom-polygon';
export const DASHBOARD_ASSETS_SUMMARY = 'dashboard-assets-summary';
export const DASHBOARD_ASSETS_SUMMARY_ORGANIZATION = 'dashboard-assets-summary-organization';
export const DASHBOARD_ASSET_SUMMARY = 'dashboard-asset-summary';
export const DASHBOARD_ASSET_SUMMARY_PER_ORGANIZATION = 'dashboard-asset-summary-per-organization';
export const DASHBOARD_ASSET_SUMMARY_PER_ORGANIZATION_EXPORT = 'dashboard-asset-summary-per-organization-export';
export const DASHBOARD_ASSET_TYPES_SUMMARY = 'dashboard-assets-summary-types';
export const DASHBOARD_ASSET_TYPES_SUMMARY_EXPORT = 'dashboard-assets-summary-types-export';
export const DASHBOARD_ASSET_TYPES_SUMMARY_ORGANIZATION = 'dashboard-assets-types-summary-organization';
export const DASHBOARD_ASSET_TYPES_SUMMARY_ORGANIZATION_EXPORT = 'dashboard-assets-summary-types-export';
export const DASHBOARD_ASSET_TYPES_SUMMARY_PER_ORGANIZATION = 'dashboard-assets-summary-types-per-organization';
export const DASHBOARD_ASSET_TYPES_SUMMARY_PER_ORGANIZATION_EXPORT = 'dashboard-assets-summary-types-per-organization-export';
export const DASHBOARD_ASSET_TYPE_SUMMARY = 'dashboard-assets-summary-type';
export const DASHBOARD_RENTS_SUMMARY = 'dashboard-rents-summary';
export const DASHBOARD_RENTS_SUMMARY_EXPORT = 'dashboard-rents-summary-export';
export const DASHBOARD_RENTS_SUMMARY_ORGANIZATION = 'dashboard-rents-summary-organization';
export const DASHBOARD_RENT_GENERAL_SUMMARY = 'dashboard-rent-general-summary';
export const DASHBOARD_RENT_SUMMARY = 'dashboard-rent-summary';
export const DASHBOARD_REQUEST_STATUSES_SUMMARY = 'dashboard-request-statuses-summary';
export const DASHBOARD_REQUEST_STATUSES_SUMMARY_BY_STATUS = 'dashboard-request-statuses-summary-by-status';
export const DASHBOARD_REQUEST_STATUSES_SUMMARY_BY_STATUS_EXPORT = 'dashboard-request-statuses-summary-by-status-export';
export const DASHBOARD_REQUEST_STATUSES_SUMMARY_EXPORT = 'dashboard-request-statuses-summary-export';
export const DASHBOARD_REQUEST_STATUSES_SUMMARY_ORGANIZATION = 'dashboard-request-statuses-summary-organization';
export const DASHBOARD_REQUEST_STATUSES_SUMMARY_ORGANIZATION_BY_STATUS_EXPORT = 'dashboard-request-statuses-summary-organization-by-status-export';
export const DASHBOARD_REQUEST_STATUS_SUMMARY = 'dashboard-request-status-summary';
export const DATES_OOKLA = 'dates-ookla';
export const DEFAULT_SECTORS_SETTINGS = 'default-sectors-settings';
export const DELETE_APPROVAL_UNIT = 'delete-approval-unit';
export const DELETE_ASSET = 'delete-asset';
export const DELETE_ASSETS = 'delete-assets';
export const DELETE_ASSET_SUB_TYPE = 'delete-asset-sub-type';
export const DELETE_ASSET_TYPE = 'delete-asset-type';
export const DELETE_ASSIGNMENT_APPROVAL_UNIT = 'delete-assignment-approval-unit';
export const DELETE_BRANDING_SETUP = 'delete-branding-setup';
export const DELETE_KPI_ALERTS = 'delete-kpi-notifications';
export const DELETE_MILESTONES = 'delete-milestones';
export const DELETE_POLYGON = 'delete-polygon';
export const DELETE_PORTAL_FILES = 'delete-portal-files';
export const DELETE_PRESET = 'delete-preset';
export const DELETE_PRESET_THRESHOLDS = 'delete-preset-thresholds';
export const DELETE_PRESET_TREE = 'delete-preset-tree';
export const DELETE_PROJECTS = 'delete-projects';
export const DELETE_SECTORS_SETTINGS = 'delete-sectors-settings';
export const DELETE_TASKS = 'delete-tasks';
export const DELETE_TECHNOLOGY = 'delete-technology';
export const DEVICE_TYPES_OOKLA = 'device-types-ookla';
export const DISABLE_2FA = 'disable-2fa';
export const DISABLE_KAI_ASSISTANTS = 'disable-kai-assistants';
export const DOWNLOAD_ASSET_SAMPLE = 'download-asset-sample-file';
export const DOWNLOAD_CROWDCELL_CONFIG = 'downloadCrowdCellConfig';
export const DOWNLOAD_FILE = 'download-file';
export const DOWNLOAD_HISTORY = 'download-history';
export const DOWNLOAD_HISTORY_DELETE_FILES = 'download-history-delete-files';
export const DOWNLOAD_HISTORY_EXPORT_FILES = 'download-history-export-files';
export const DOWNLOAD_HISTORY_SOURCES = 'download-history-sources';
export const DOWNLOAD_HISTORY_STATUSES = 'download-history-statuses';
export const DOWNLOAD_POLYGON_SAMPLE = 'download-polygon-sample-file';
export const DOWNLOAD_PORTAL_FILES = 'download-portal-files';
export const DOWNLOAD_SITES_SAMPLE = 'download-sites-sample-file';
export const DOWNLOAD_URL = 'download-url';
export const DRILL_DOWN_CHARTS = 'drill-down-charts';
export const DRILL_DOWN_COMPARE_CHARTS = 'drill-down-charts';
export const EDIT_ALARM = 'edit-alarm';
export const EDIT_BRANDING_SETUP = 'edit-branding-setup';
export const EDIT_KPI_ALERT = 'edit-kpi-notifications';
export const EDIT_PRESET_THRESHOLDS = 'edit-preset-thresholds';
export const EDIT_SITE = 'edit-site';
export const EDIT_TECHNOLOGY = 'edit-technology';
export const EDIT_THRESHOLDS = 'edit-thresholds';
export const ENABLE_KAI_ASSISTANTS = 'enable-kai-assistants';
export const ERRORS_FILTER_LIST = 'errors-filter-list';
export const ERRORS_LIST = 'errors-list';
export const ERROR_CODE_EDIT = 'error-code-edit';
export const EXPORT_ACQUIRED_ASSETS = 'export-acquired-assets';
export const EXPORT_ACTIVE_ALARMS_FLEXIDAS = 'export-active-alarms-flexidas';
export const EXPORT_ALARM_HISTORY = 'export-alarm-history';
export const EXPORT_ALARM_HISTORY_FLEXIDAS = 'export-alarm-history-flexidas';
export const EXPORT_ALL_CELLS = 'export-all-cells';
export const EXPORT_ASSET = 'export-assets';
export const EXPORT_ASSET_FILE = 'export-assets-file';
export const EXPORT_ASSET_RULES = 'export-assets-rules';
export const EXPORT_ASSET_RULES_UPDATE = 'export-assets-rules-update';
export const EXPORT_CELLS_BY_TECHNOLOGY = 'export-cells-by-technology';
export const EXPORT_CHARTS = 'export-charts';
export const EXPORT_CHARTS_PARAMS = 'export-charts-params';
export const EXPORT_COMPARE_CHARTS = 'export-compare-charts';
export const EXPORT_CORRELATE_CHARTS = 'export-correlate-charts';
export const EXPORT_POLYGONS_ASSETS = 'export-polygons-assets';
export const EXPORT_THRESHOLDS = 'export-thresholds';
export const FIELD_SAMPLES = 'field-samples';
export const FIELD_SITES_SAMPLES = 'field-sites-samples';
export const FILTER_APPROVAL_USERS = 'filter-approval-users';
export const FILTER_ASSIGN_APPROVAL_UNITS = 'filter-assign-approval-units';
export const FILTER_THRESHOLDS = 'filterThresholds';
export const GENERATE_SITE_ID = 'generate-site-id';
export const GET_ASSET_OWNERS = 'get-asset-owners';
export const GET_DEFAULT_GNODEB_CONFIG_PARAMETERS = 'get-default-gnodeb-config-parameters';
export const GET_KAI_ASSISTANTS = 'get-kai-assistants';
export const GET_KAI_ASSISTANT_BY_USER = 'get-kai-assistant-by-user';
export const GET_KAI_NOT_ASSIGNED_USERS = 'get-kai-not-assigned-users';
export const GET_NETWORK_OPERATORS = 'get-network-operators';
export const GET_PORTAL_AVAILABLE_MILESTONES = 'get-portal-available-milestones';
export const GET_PORTAL_FILES = 'get-portal-files';
export const GET_PORTAL_FILES_USERS = 'get-portal-files-users';
export const GET_PORTAL_FILES_MILESTONES = 'get-portal-files-milestones';
export const GET_PORTAL_FILES_MILESTONES_FILTER = 'get-portal-files-milestones-filter';
export const GET_PORTAL_FILES_MILESTONES_TO_LINK = 'get-portal-files-milestones-to-link';
export const GET_PORTAL_FOLDERS = 'get-portal-folders';
export const GET_PORTAL_FOLDERS_MOVE_DESTINATIONS = 'get-portal-folders-move-destinations';
export const GET_PORTAL_MILESTONE = 'get-portal-milestone';
export const GET_PORTAL_MILESTONES = 'get-portal-milestones';
export const GET_PORTAL_MILESTONES_GROUPED_TASKS_TO_LINK = 'get-portal-milestones-grouped-tasks-to-link';
export const GET_PORTAL_PROJECT = 'get-portal-project';
export const GET_PORTAL_PROJECTS_LIST = 'get-portal-projects-list';
export const GET_PORTAL_TASK = 'get-portal-task';
export const GET_PORTAL_TASKS = 'get-portal-tasks';
export const GET_PORTAL_TASKS_TO_LINK = 'get-portal-tasks-to-link';
export const GET_PORTAL_TIMELINE = 'get-portal-timeline';
export const GET_PORTAL_TIMELINE_MILESTONES_FILTER = 'get-portal-timeline-milestones_filter';
export const GET_PORTAL_UPLOAD_FILES = 'get-portal-upload-files';
export const GET_PROJECTS_LIST = 'get-projects-list';
export const GET_SEVERITIES = 'get-severities';
export const GNODEB_CONFIG_PARAMETERS = 'gnodeb-config-parameters';
export const GOLDEN_SETTING = 'golden-settings';
export const GOLDEN_SETTING_CREATE_URL = 'golden-settings-create-url';
export const GOLDEN_SETTING_DATES = 'golden-settings-dates';
export const GOLDEN_SETTING_DATES_MAVENIR = 'golden-settings-dates-mavenir';
export const GOLDEN_SETTING_EDIT = 'golden-settings-edit';
export const GOLDEN_SETTING_EXPORT = 'golden-settings-export';
export const GOLDEN_SETTING_IMPORT = 'golden-settings-import';
export const GOLDEN_SETTING_INFO = 'golden-settings-info';
export const GOLDEN_SETTING_ON_SELECTED_DATE = 'golden-settings-on-selected-date';
export const GOLDEN_SETTING_ON_SELECTED_DATE_MAVENIR = 'golden-settings-on-selected-date-mavenir';
export const GOLDEN_SETTING_RESET = 'golden-settings-reset';
export const GOLDEN_SETTING_RESET_AND_SET = 'golden-settings-reset-and-set';
export const GOLDEN_SETTING_SAMPLE = 'golden-settings-sample';
export const GOLDEN_SETTING_SET = 'golden-settings-set';
export const GOLDEN_SETTING_SITES = 'golden-settings-sites';
export const GOLDEN_SETTING_TREE_BY_PATH = 'golden-settings-tree-by-path';
export const GOLDEN_SETTING_VALIDATION_RULES = 'golden-settings-validation-rules';
export const HC_BRANCHES_EXPORT = 'hc-branches-export';
export const HC_BRANCH_DETAILS_EXPORT = 'hc-branch-details-export';
export const HC_BRANCH_PARAMETERS_EXPORT = 'hc-branch-patameters-export';
export const HC_AWTG_RAN_BRANCHES_EXPORT = 'hc-awtg-ran-branches-export';
export const HC_AWTG_RAN_PATH_EXPORT = 'hc-awtg-ran-path-export';
export const HC_AWTG_RAN_PATH_PARAMETER_EXPORT = 'hc-awtg-ran-path-parameter-export';
export const HIDE_KAI_ASSISTANTS = 'hide-kai-assistants';
export const HISTORY_2FA = 'history-2fa';
export const HISTORY_ALARMS_ORAN = 'history-alarms-oran';
export const HISTORY_CHECK_BRANCHES = 'history-check-branches';
export const HISTORY_CHECK_BRANCHES_FETCH = 'history-check-branches-fetch';
export const HISTORY_CHECK_CONFIG_TYPES = 'history-check-config-types';
export const HISTORY_CHECK_DATES = 'history-check-dates';
export const HISTORY_CHECK_DATES_OPTIONS = 'history-check-dates-options';
export const HISTORY_CHECK_DELETE_PROGRESS = 'history-check-delete-progress';
export const HISTORY_CHECK_DETAILS = 'history-check-details';
export const HISTORY_CHECK_DETAILS_RAN = 'history-check-details-ran';
export const HISTORY_CHECK_GET_PROGRESS = 'history-check-get-progress';
export const HISTORY_CHECK_NODE = 'history-check-node';
export const HISTORY_CHECK_NODES = 'history-check-nodes';
export const HISTORY_CHECK_PARAMETER_FILTER = 'history-check-parameter-filter';
export const HISTORY_CHECK_RUN_PROGRESS = 'history-check-run-progress';
export const HISTORY_CHECK_AWTG_RAN_RUN_PROGRESS = 'history-check-awtg-ran-run-progress';
export const HISTORY_CHECK_AWTG_RAN_GET_PROGRESS = 'history-check-awtg-ran-get-progress';
export const HISTORY_CHECK_AWTG_RAN_BRANCHES_FETCH = 'history-check-awtg-ran-branches-fetch';
export const HISTORY_CHECK_SITEID_FILTER = 'history-check-siteid-filter';
export const HISTORY_CHECK_SITE_IDS = 'history-check-site-ids';
export const HISTORY_CHECK_TECHNOLOGY = 'history-check-technology';
export const HISTORY_CHECK_VENDOR = 'history-check-vendor';
export const HISTORY_CHECK_VERSIONS = 'history-check-versions';
export const HISTORY_CHECK_AWTG_RAN_CONFIG_TYPES = 'history-check-awtg-ran-config-types';
export const HISTORY_CHECK_AWTG_RAN_NETWORK_ELEMENTS = 'history-check-awtg-ran-network-elements';
export const HISTORY_CHECK_AWTG_RAN_DATES = 'history-check-awtg-ran-dates';
export const HISTORY_CHECK_MO_IDS = 'history-check-mo-ids';
export const HISTORY_CHECK_MO_NAMES = 'history-check-mo-names';
export const HISTORY_CHECK_NE_NAMES = 'history-check-ne-names';
export const IMPORT_EXECUTE = 'import-execute';
export const IMPORT_SITES_EXECUTE = 'import-sites-execute';
export const IMPORT_SITES_STATISTIC = 'import-sites-statistic';
export const IMPORT_SITES_TYPES = 'import-sites-types';
export const IMPORT_STATISTIC = 'import-statistic';
export const IMPORT_TYPES = 'import-types';
export const KPI_ALERTS = 'kpi-notifications';
export const KPI_ALERTS_BY_ID = 'kpi-notifications-by-id';
export const KPI_ALERTS_EXPORT = 'kpi-notifications-export';
export const KPI_ALERTS_HISTORY = 'kpi-notifications-history';
export const KPI_ALERTS_ORAN = 'kpi-notifications-oran';
export const KPI_ALERTS_RECIPIENTS = 'kpi-notifications';
export const KPI_ALERT_VENDORS_DROPDOWN = 'kpi-alerts-vendors-dropdown';
export const KPI_CHARTS = 'kpi-charts';
export const KPI_CHARTS_DRILL_DOWN = 'kpi-charts-drill-down';
export const KPI_GROUP = 'kpi-group';
export const KPI_NOTIFICATIONS_HISTORY_EXPORT = 'kpi-notifications-history-export';
export const KPI_PROGRESS = 'kpi-progress';
export const KPI_PROGRESS_DRILL_DOWN = 'kpi-progress-drill-down';
export const KPI_SETTINGS = 'kpi-settings';
export const KPI_DYNAMIC_DATES = 'kpi-dynamic-dates';
export const KPI_DYNAMIC_DATES_PREVIEW = 'kpi-dynamic-dates-preview';
export const KPI_START_PROGRESS = 'kpi-start-progress';
export const KPI_START_PROGRESS_DRILL_DOWN = 'kpi-start-progress-drill-down';
export const LIMENET_CELLS = 'limenet-cells';
export const LINK_SITE_TO_ASSET = 'link-site-to-asset';
export const LINK_SITE_TO_CROWDCELL = 'link-site-to-crowdcell';
export const MANAGE_ACQUIRE_ASSETS_ASSET_OWNERS = 'manage-acquire-assets-asset-owners';
export const MANAGE_ASSET_TYPES = 'manage-asset-types';
export const MAVENIR_CONFIG = 'mavenir-config';
export const MAVENIR_CONFIGS = 'mavenir-configs';
export const MAVENIR_CONFIGS_DELETE = 'delete-mavenir-configs';
export const MAVENIR_CONFIG_CREATE = 'create-mavenir-config';
export const MAVENIR_CONFIG_DATES = 'mavenir-config-dates';
export const MAVENIR_CONFIG_DELETE = 'delete-mavenir-config';
export const MAVENIR_CONFIG_DOWNLOAD = 'download-mavenir-config';
export const MAVENIR_CONFIG_EXPORT = 'export-mavenir-config';
export const MAVENIR_CONFIG_GNB_IDS = 'mavenir-config-gnb-ids';
export const MAVENIR_CONFIG_IDS = 'mavenir-config-ids';
export const MAVENIR_CONFIG_TYPES = 'mavenir-config-types';
export const MAVENIR_CONFIG_UPLOAD = 'upload-mavenir-config';
export const MAVENIR_CONFIG_VERSIONS = 'mavenir-config-versions';
export const MAVENIR_CONFIG_VIEW = 'view-mavenir-config';
export const MAVENIR_SCHEMA_CONFIG = 'mavenir-schema-configs';
export const MAVENIR_SCHEMA_VIEW = 'view-schema-config';
export const MEASUREMENT_NAMES_OOKLA = 'measurement-names-ookla';
export const MIDDLEWARE_LOG_PM_DISABLE = 'middleware-log-pm-disable';
export const MIDDLEWARE_LOG_PM_ENABLE = 'middleware-log-pm-enable';
export const MIDDLEWARE_LOG_PM_UPDATE = 'middleware-log-pm-update';
export const MIDDLEWARE_SMO = 'middleware-smo';
export const MIDDLEWARE_SMO_DISABLE = 'middleware-smo-disable';
export const MIDDLEWARE_SMO_ENABLE = 'middleware-smo-enable';
export const MIDDLEWARE_SMO_REMOVE = 'middleware-smo-remove';
export const MIDDLEWARE_SMO_STATUSES = 'middleware-smo-statuses';
export const MIDDLEWARE_SMO_VENDORS = 'middleware-smo-vendors';
export const MIDDLEWARE_SMO_CONNECTION_LOGS = 'middleware-smo-connection-logs';
export const MIDDLEWARE_SMO_CONNECTION_LOGS_USERS = 'middleware-smo-connection-logs-users';
export const MIDDLEWARE_SMO_CONNECTION_LOGS_CONNECTION_STATUSES = 'middleware-smo-connection-logs-connection-statuses';
export const MIDDLEWARE_SMO_CONNECTION_LOGS_EVENT_TYPES = 'middleware-smo-connection-logs-event-types';
export const MIDDLEWARE_SMO_CONNECTION_LOGS_MIDDLEWARES = 'middleware-smo-connection-logs-middlewares';
export const MIDDLEWARE_SMO_CONNECTION_LOGS_SOURCES = 'middleware-smo-connection-logs-sources';
export const MO_BRANCH = 'mo-branch';
export const MO_BRANCHES = 'mo-branches';
export const MO_BRANCHES_EXPORT = 'mo-branches-export';
export const MO_BRANCHES_GET_PATHS = 'mo-branches-get-paths';
export const MO_BRANCHES_PROGRESS = 'mo-branches-progress';
export const MO_BRANCHES_START_PROGRESS = 'mo-branches-start-progress';
export const MO_BRANCH_CONFIG_IDS = 'mo-branch-configIds';
export const MO_BRANCH_DELTAS = 'mo-branch-deltas';
export const MO_BRANCH_EXPORT = 'mo-branch-export';
export const MO_BRANCH_GNB_IDS = 'mo-branch-gnbIds';
export const MO_BRANCH_PARAMETERS = 'mo-branch-parameters';
export const MO_BRANCH_SITE_IDS = 'mo-branch-siteIds';
export const MO_DETAILS_OPTIONS = 'mo-details-options';
export const MO_NAMES = 'mo-names';
export const MO_PRESET_BRANCHES = 'mo-preset-branches';
export const NETCONF_EVENTS = 'netconf-events';
export const NETCONF_EVENTS_DROPDOWNS = 'netconf-events-dropdowns';
export const NETCONF_EVENTS_EXPORT = 'netconf-events-export';
export const NETCONF_EVENT_EVENTS_TYPES = 'netconf-event-events-types';
export const NETCONF_EVENT_MIDDLEWARES = 'netconf-event-middleware';
export const NETCONF_EVENT_NETWORK_ELEMETNS = 'netconf-event-network-elements';
export const NETCONF_EVENT_VENDORS = 'netconf-event-vendors';
export const NETCONF_EVENT_RAW_DATA = 'netconf-event-raw-data';
export const NETWORK_ELEMENTS = 'network-elements';
export const NETWORK_ELEMENTS_AUTO_SWITCH_AVAILABLE = 'network-elements-auto-switch-available';
export const NETWORK_ELEMENTS_CHECK_IP_ADDRESS = 'network-elements-ip-address';
export const NETWORK_ELEMENTS_CHECK_NAME = 'network-elements-check-name';
export const NETWORK_ELEMENTS_CHECK_PATH = 'network-elements-check-name';
export const NETWORK_ELEMENTS_CHECK_VES_CU = 'network-elements-check-ves-cu';
export const NETWORK_ELEMENTS_CHECK_VES_DU = 'network-elements-check-ves-Du';
export const NETWORK_ELEMENTS_CONNECT = 'network-elements-connect';
export const NETWORK_ELEMENTS_CONNECTION_LOGS = 'network-elements-connection-logs';
export const NETWORK_ELEMENTS_CONNECTION_OPTIONS = 'network-elements-connection-options';
export const NETWORK_ELEMENTS_CREATE = 'network-elements-create';
export const NETWORK_ELEMENTS_DELETE = 'network-elements-delete';
export const NETWORK_ELEMENTS_DISABLE_AUTO_SWITCH = 'network-elements-disable-auto-switch';
export const NETWORK_ELEMENTS_DISABLE_SFTP = 'network-elements-disable-sftp';
export const NETWORK_ELEMENTS_EDIT = 'network-elements-edit';
export const NETWORK_ELEMENTS_EDIT_AUTO_SWITCH = 'network-elements-edit-auto-switch';
export const NETWORK_ELEMENTS_ENABLE_AUTO_SWITCH = 'network-elements-enable-auto-switch';
export const NETWORK_ELEMENTS_ENABLE_SFTP = 'network-elements-enable-sftp';
export const NETWORK_ELEMENTS_ESTABLISHED_OPTIONS = 'network-elements-established-options';
export const NETWORK_ELEMENTS_MIDDLEWARE_OPTIONS = 'network-elements-middleware-options';
export const NETWORK_ELEMENTS_ELEMENT_TYPE_OPTIONS = 'network-elements-element-type-options';
export const NETWORK_ELEMENTS_NAMES_OPTIONS = 'network-elements-names-options';
export const NETWORK_ELEMENTS_VENDORS_OPTIONS = 'network-elements-vendors-options';
export const NETWORK_ELEMENTS_STATUSES_OPTIONS = 'network-elements-statuses-options';
export const NETWORK_ELEMENTS_SUBSCRIBE = 'network-elements-subscribe';
export const NETWORK_ELEMENTS_SUBSCRIPTION_OPTIONS = 'network-elements-subscription-options';
export const NETWORK_ELEMENTS_TYPE_OPTIONS = 'network-elements-type-options';
export const NETWORK_ELEMENTS_VES_CU_PATH = 'network-elements-ves-cu-path';
export const NETWORK_ELEMENTS_VES_DU_PATH = 'network-elements-ves-du-path';
export const NETWORK_ELEMENT_CANCEL_ALL_ACCEPTED = 'network-elements-cancel-all-accepted';
export const NETWORK_ELEMENT_CANCEL_CHANGE_MONITORING = 'network-elements-cancel-change-monitoring';
export const NETWORK_ELEMENT_CHANGES_MONITORING_CARD = 'network-element-changes-monitoring-card';
export const NETWORK_ELEMENT_CHANGE_MONITORING = 'network-elements-change-monitoring';
export const NETWORK_ELEMENT_CHANGE_MONITORING_ERROR_MESSAGE = 'network-elements-change-monitoring-error-message';
export const NETWORK_ELEMENT_CHANGE_MONITORING_GROUPS = 'network-elements-change-monitoring-groups';
export const NETWORK_ELEMENT_CHANGE_MONITORING_HISTORY = 'network-elements-change-monitoring-history';
export const NETWORK_ELEMENT_CHANGE_MONITORING_STATUSES = 'network-elements-change-monitoring-statuses';
export const NETWORK_ELEMENT_CHANGE_MONITORING_STATUSES_HISTORY = 'network-elements-change-monitoring';
export const NETWORK_ELEMENT_CHANGE_MONITORING_USERS = 'network-elements-change-monitoring-users';
export const NETWORK_ELEMENT_COMMIT_ALL_ACCEPTED_CHANGE_MONITORING = 'network-elements-commit-all-accepted-change-monitoring';
export const NETWORK_ELEMENT_COMMIT_CHANGE_MONITORING = 'network-elements-commit-change-monitoring';
export const NETWORK_ELEMENT_CONFIGURATIONS = 'network-elements-configurations';
export const NETWORK_ELEMENT_CONFIGURATIONS_EXPORT = 'network-elements-configurations-export';
export const NETWORK_ELEMENT_CONFIGURATION_BY_DATE = 'network-elements-configuration-by-date';
export const NETWORK_ELEMENT_CONFIGURATION_CANDIDATE = 'network-elements-configuration-candidate';
export const NETWORK_ELEMENT_CONFIGURATION_DATES = 'network-elements-configuration-dates';
export const NETWORK_ELEMENT_CONFIGURATION_EXPORT = 'network-elements-configuration-export';
export const NETWORK_ELEMENT_CONFIGURATION_LATEST = 'network-elements-configuration-latest';
export const NETWORK_ELEMENT_CONFIGURATION_MIDDLEWARES = 'network-elements-configuration-middlewares';
export const NETWORK_ELEMENT_CONFIGURATION_STATUSES = 'network-elements-configuration-statuses';
export const NETWORK_ELEMENT_CONFIGURATION_TIMESTAMPS = 'network-elements-configuration-timestamps';
export const NETWORK_ELEMENT_CONFIGURATION_TYPES = 'network-elements-configuration-types';
export const NETWORK_ELEMENT_EDIT_CHANGE_MONITORING = 'network-elements-edit-change-monitoring';
export const NETWORK_ELEMENT_NOTES = 'network-elements-notes';
export const NETWORK_ELEMENT_TRY_AGAIN_CHANGE_MONITORING = 'network-elements-try-again-change-monitoring';
export const NETWORK_ELEMENT_VALIDATION_RULES = 'network-elements-validation-rules';
export const NOKIA_CELLS = 'nokia-cells';
export const NON_REQUIRED_FIELDS = 'non-required-fields';
export const NOTIFICATIONS = 'notifications';
export const OOKLA_MEASUREMENTS_ALL = 'ookla-measurements-all';
export const OPERATION_WINDOW_RULES = 'operation-window-rules';
export const OPERATION_WINDOW_RULES_CHECK_NAME = 'operation-window-rules-check-name';
export const OPERATION_WINDOW_RULE_NOTES = 'operation-window-rule-notes';
export const OPERATION_WINDOW_RULES_CREATE = 'operation-window-rules-create';
export const OPERATION_WINDOW_RULES_DELETE = 'operation-window-rules-delete';
export const OPERATION_WINDOW_RULES_DELETE_MANY = 'operation-window-rules-delete-many';
export const OPERATION_WINDOW_RULES_EDIT = 'operation-window-rules-edit';
export const OPERATION_WINDOW_RULES_EDIT_NOTES = 'operation-window-rules-edit-notes';
export const OPTIONS_GRANULARITIES = 'options-granularities';
export const OPTIONS_GRANULARITIES_AUTOMATIC = 'options-granularities-automatic';
export const OPTIONS_LIMENET_KPI = 'options-limenet-kpi';
export const OPTIONS_LIMENET_KPI_LINE_TYPE = 'options-limenet-kpi-line-type';
export const OPTIONS_NOKIA_KPI = 'options-nokia-kpi';
export const OPTIONS_NOKIA_KPI_LINE_TYPE = 'options-nokia-kpi-line-type';
export const OPTIONS_ORAN_KPI_LINE_TYPE = 'options-oran-kpi-line-type';
export const OPTIONS_T_4G_FDD_LIMENET = 'options-T4GFdd-limenet';
export const OPTIONS_T_4G_FDD_NOKIA = 'options-T4GFdd-nokia';
export const OPTIONS_T_4G_TDD_LIMENET = 'options-T4GTdd-limenet';
export const OPTIONS_T_4G_TDD_NOKIA = 'options-T4GTdd-nokia';
export const OPTIONS_T_5G_LIMENET = 'options-T5G-limenet';
export const OPTIONS_T_5G_NOKIA = 'options-T5G-nokia';
export const OPTIONS_T_5G_ORAN = 'options-T5G-RAN';
export const ORAN_ALARM_ACKNOWLEDGED_BY = 'oran-alarm-acknowledged-by';
export const ORAN_ALARM_CLEARED_BY = 'oran-all-cleared-by';
export const ORAN_MIDDLEWARES = 'oran-middlewares';
export const ORAN_NETWORK_ELEMENTS = 'oran-network-elements';
export const ORAN_USER_GROUPS_FOR_ALARMS = 'oran-user-groups-for-alarms';
export const ORAN_VALUES_FOR_CREATE_SCHEMA = 'oran-values-for-create-schema-config';
export const ORGANISATIONS = 'organisations';
export const ORGANISATIONS_ACTIVE = 'organisations-active';
export const ASSET_OWNERS_FOR_FILTER = 'asset-owners-for-filter';
export const ORGANISATION_MAP_SETTINGS = 'organisation-map-settings';
export const ORGANISATION_PROFILE = 'organisation-profile';
export const ORGANISATION_PROJECTS_ADMINS = 'organisation-projects-admins';
export const ORGANISATION_PROJECTS_MEMBERS = 'organisation-projects-members';
export const ORGANISATION_PROJECTS_STATUSES = 'organisation-projects-statuses';
export const ORGANISATION_PROJECTS_WORKFLOWS = 'organisation-projects-workflows';
export const ORGANISATION_ROLES = 'organisation-roles';
export const ORGANISATION_SETTINGS = 'organisation-settings';
export const ORGANISATION_SETTINGS_VENDORS = 'organisation-settings-vendors';
export const ORGANISATION_TYPES = 'organisation-types';
export const ORGANIZATIONS_USERS = 'organizations-users';
export const ORGANIZATIONS_USERS_APPROVERS = 'organizations-users-approvers';
export const ORGANIZATIONS_SWITCH = 'organizations-switch';
export const ORGANISATIONS_SWITCH_ADD = 'organisations-switch-add';
export const ORGANISATIONS_SWITCH_REMOVE = 'organisations-switch-remove';
export const PASSWORD_HISTORY_2FA = 'password-history-2fa';
export const POLYGON_SYSTEM_FIELDS = 'polygon-system-fields';
export const PORTAL_AVAILABLE_PROJECTS = 'portal-available-projects';
export const PORTAL_CHECK_FOLDER_NAME = 'portal-folders-create';
export const PORTAL_DELETE_FOLDER = 'portal-delete-folder';
export const PORTAL_DOWNLOAD_FOLDER = 'portal-download-folder';
export const PORTAL_FOLDERS_CREATE = 'portal-folders-create';
export const PORTAL_MILESTONES_ASSIGNEES = 'portal-milestones-assignees';
export const PORTAL_MILESTONES_ASSIGNEES_FILTER = 'portal-milestones-assignees-filter';
export const PORTAL_MILESTONES_CREATE = 'portal-milestones-create';
export const PORTAL_MILESTONES_STATUSES = 'portal-milestones-statuses';
export const PORTAL_MOVE_FILES = 'portal-move-files';
export const PORTAL_MOVE_FOLDER = 'portal-move-folder';
export const PORTAL_PROJECTS_ADMINS = 'portal-projects-admins';
export const PORTAL_PROJECTS_MEMBERS = 'portal-projects-members';
export const PORTAL_PROJECTS_STATUSES = 'portal-projects-statuses';
export const PORTAL_RENAME_FOLDER = 'portal-rename-folder';
export const PORTAL_TASKS_ASSIGNEES = 'portal-tasks-assignees';
export const PORTAL_TASKS_ASSIGNEES_FILTER = 'portal-tasks-assignees-filter';
export const PORTAL_TASKS_CREATE = 'portal-tasks-create';
export const PORTAL_TASKS_LINK_TYPES = 'portal-tasks-link-types';
export const PORTAL_TASKS_PRIORITIES = 'portal-tasks-priorities';
export const PORTAL_TASKS_STATUSES = 'portal-tasks-statuses';
export const PORTAL_TIMELINE_ASSIGNEES_FILTER = 'portal-milestones-assignees-filter';
export const PORTAL_TIMELINE_PRIORITIES = 'portal-timeline-priorities';
export const PORTAL_TIMELINE_STATUSES = 'portal-timeline-statuses';
export const PRESETS_THRESHOLD = 'presets-threshold';
export const PRESET_OPTIONS = 'preset-options';
export const PRESET_TREE = 'create-preset';
export const PREVIEW_CONFIG_FILE = 'preview-config-file';
export const QUERY_ASSET = 'query-asset';
export const RU_DASHBOARD_STATUSES = 'ru-dashboard-statuses';
export const RU_DASHBOARD_INTERFACES = 'ru-dashboard-interfaces';
export const RU_DASHBOARD_ADMINISTRATIVE_STATE = 'ru-dashboard-administrative-state';
export const RU_DASHBOARD_OPERATIONAL_STATE = 'ru-dashboard-operational-state';
export const RU_DASHBOARD_USAGE_STATE = 'ru-dashboard-usage-state';
export const RU_DASHBOARD_POWER_STATE = 'ru-dashboard-power-state';
export const RU_DASHBOARD_AVAILABILITY_STATE = 'ru-dashboard-availability-state';
export const RU_DASHBOARD_SYNCHRONIZATION_STATE = 'ru-dashboard-synchronization-state';
export const RU_DASHBOARD_LOCK = 'ru-dashboard-lock';
export const RU_DASHBOARD_USAGE_CARRIER_STATE = 'ru-dashboard-usage-carrier-state';
export const RU_DASHBOARD_ACTIVE_CARRIER_STATE = 'ru-dashboard-active-carrier-state';
export const RU_DASHBOARD_STATUS_CARRIER_STATE = 'ru-dashboard-status-carrier-state';
export const RELINK_CROWDCELL = 'relink-crowdcell';
export const REMOVE_CELL = 'remove-cell';
export const REMOVE_CELLS = 'remove-cells';
export const REMOVE_KAI_ASSISTANT = 'remove-kai-assistant';
export const REMOVE_SITE = 'remove-site';
export const REMOVE_SITES = 'remove-sites';
export const RENT_REQUESTS_PICKED_DATES = 'rent-requests-picked-dates';
export const RENT_REQUESTS_PICKED_DATES_UPDATE = 'rent-requests-picked-dates-update';
export const RESPONSIBLE = 'responsible';
export const REVOKED_ROLES = 'revoked-roles';
export const REWRITE_LINKED_SITES_COORDINATES = 'rewrite-linked-sites-coordinates';
export const REWRITE_SITE_COORDINATES = 'rewrite-site-coordinates';
export const REWRITE_SITE_COORD_AND_RELINK = 'rewrite-site-coord-and-relink';
export const ROLES = 'roles';
export const ROLES_TO_CREATE = 'roles-to-create';
export const RU_CONFIGURATIONS = 'ru-configurations';
export const RU_CONFIGURATIONS_MIDDLEWARES = 'ru-configurations-middlewares';
export const RU_CONFIGURATIONS_STATUSES = 'ru-configurations-statuses';
export const RU_CONFIGURATIONS_CONFIGS = 'ru-configurations-configs';
export const RU_CONFIGURATIONS_NETCONFS = 'ru-configurations-netconfs';
export const RU_CONFIGURATIONS_USERS = 'ru-configurations-users';
export const RU_CONFIGURATION_CREATE = 'ru-configuration-create';
export const RU_CONFIGURATION_UPDATE = 'ru-configuration-update';
export const SAVE_FIELDS_MAPPING = 'save-fields-mapping';
export const SAVE_IMPORT_RULES = 'saveImportRules';
export const SAVE_IMPORT_SITES_RULES = 'save-import-sites-rules';
export const SAVE_SITES_FIELDS_MAPPING = 'save-sites-fields-mapping';
export const SCHEMA_CONFIG_CLEAR = 'delete-schema-clear';
export const SCHEMA_CONFIG_DELETE = 'delete-schema-config';
export const SCHEMA_CONFIG_EXPORT = 'schema-configexport';
export const SCHEMA_CONFIG_REBUILD = 'delete-schema-rebuild';
export const SECTOR_SETS = 'sector-sets';
export const SELECTED_PRESET_TREE = 'selected-preset-tree';
export const SEND_CODE_2FA = 'send-code-2fa';
export const SEND_CODE_2FA_FOR_PASSWORD = 'send-code-2fa-for-password';
export const SEND_CODE_TO_NUMBER = 'send-code-to-number';
export const SEND_CODE_TO_NUMBER_FOR_PASSWORD = 'send-code-to-number-for-password';
export const SETTINGS = 'settings';
export const SET_DEFAULT_KAI_ASSISTANT = 'set-default-kai-assistant';
export const SET_KPI_VENDOR = 'set-kpi-vendor';
export const SET_NON_DEFAULT_KAI_ASSISTANT = 'set-default-non-kai-assistant';
export const SITES_BY_SITE_IDS = 'sites-by-site-ids';
export const SITES_DB = 'sites-db';
export const SITES_SYSTEM_FIELDS = 'sites-system-fields';
export const SITES_UPLOAD_URL = 'sites-uploadURL';
export const SITE_PROFILE = 'site-profile';
export const SITE_TYPES = 'site-types';
export const STARTUP_POLYGON = 'startup-polygon';
export const SWAP_USER = 'swap-user';
export const SWAP_USERS_DROPDOWN = 'swap-users-dropdown';
export const TECHNOLOGIES = 'technologies';
export const TECHNOLOGIES_OOKLA = 'technologies-ookla';
export const THRESHOLDS = 'thresholds';
export const THRESHOLD_TECHNOLOGIES = 'threshold-technologies';
export const THRESHOLD_VENDORS = 'threshold-vendors';
export const TIMEZONES = 'timezones';
export const UNLINKED_CROWDCELLS = 'unlinked-crowdcells';
export const UNLINKED_SITES = 'unlinked-sites';
export const UNLINKED_SITES_FOR_LINK = 'sites-for-link';
export const UNLINK_CROWDCELL = 'unlink-crowdcell';
export const UNLINK_SITES_FROM_ASSET = 'unlink-sites-from-asset';
export const UNLINK_SITE_FROM_ASSET = 'unlink-site-from-asset';
export const UNHIDE_KAI_ASSISTANTS = 'unhide-kai-assistants';
export const UPDATE_APPROVAL_UNIT = 'update-approval-unit';
export const UPDATE_ASSET_SUBTYPE = 'update-asset-subtype';
export const UPDATE_ASSET_TYPE = 'update-asset-type';
export const UPDATE_ASSIGNMENT_APPROVAL_UNIT = 'update-assignment-approval-unit';
export const UPDATE_CELL_4G_FDD = 'update-cell-4G-fdd';
export const UPDATE_CELL_4G_TDD = 'update-cell-4G-tdd';
export const UPDATE_CELL_5G = 'update-cell-5G';
export const UPDATE_COMMISSION_SETTINGS = 'update-commission-settings';
export const UPDATE_GNODEB_CONFIG_PARAMETERS = 'update-gnodeb-config-parameters';
export const UPDATE_KAI_ASSISTANT = 'update-kai-assistant';
export const UPDATE_MILESTONE = 'update-milestone';
export const UPDATE_ORGANISATION_SETTINGS = 'update-organisation-settings';
export const UPDATE_POLYGON = 'update-polygon';
export const UPDATE_PORTAL_PROJECT = 'update-portal-project';
export const UPDATE_PORTAL_PROJECT_STATUS = 'update_portal-project-status';
export const UPDATE_PRESET = 'update-preset';
export const UPDATE_PRESET_NAME = 'update-preset-name';
export const UPDATE_PRESET_TREE = 'update-preset-tree';
export const UPDATE_PROJECT = 'update-project';
export const UPDATE_SECTORS_SETTINGS = 'update-sectors-settings';
export const UPDATE_TASK = 'update-task';
export const UPDATE_USER_PROFILE = 'update-user-profile';
export const UPLOAD_LOGO_URL = 'uploadLogoURL';
export const UPLOAD_URL = 'uploadURL';
export const UPLOAD_URL_ATTACHMENT = 'uploadURLAttachment';
export const UPLOAD_URL_ATTACHMENT_PORTAL_FILES = 'upload-url-attachment-portal-files';
export const UPLOAD_URL_ATTACHMENT_PORTAL_TASK = 'upload-url-attachment-portal-task';
export const UPLOAD_URL_ATTACHMENT_SCHEMA = 'uploadURLAttachmentSchema';
export const USER = 'user';
export const USER_DETAILS = 'user-details';
export const USERS = 'users';
export const DELETE_USER_AS_PO_ONE = 'delete-user-as-po-one';
export const USERS_STATUSES_AS_PO = 'users-statuses-as-po';
export const USERS_ORGANIZATIONS_AS_PO = 'users-organizations-as-po';
export const USERS_ACTIONS = 'user-actions';
export const USER_ACTIONS_FILTER = 'user-actions-filter';
export const USER_GROUP = 'user-group';
export const USER_PROFILE = 'user-profile';
export const USER_PROFILE_AS_PO = 'user-profile-as-po';
export const VALUES_FOR_CREATE_SCHEMA = 'values-for-create-schema-config';
export const VENDORS = 'vendors';
export const VENDORS_ALARMS = 'vendors-alarms';
export const VENDORS_FOR_SCHEMA = 'vendors-for-schema';
export const VENDORS_KPI = 'vendors-kpi';
export const VES_EVENTS = 'ves-events';
export const VES_EVENTS_DROPDOWN_VALUES = 'ves-events-dropdown-values';
export const VES_EXPORT = 'ves-export';
export const ZONE = 'zone';
